(function () {
  'use strict';

  /**
   * Menu toggle for 3 level navbar stuck state
  */

  const stuckNavbarMenuToggle = (() => {

    let toggler = document.querySelector('.navbar-stuck-toggler'),
    stuckMenu = document.querySelector('.navbar-stuck-menu');

    if (toggler == null) return;

    toggler.addEventListener('click', function (e) {
      stuckMenu.classList.toggle('show');
      e.preventDefault();
    });

  })();

  /**
   * Cascading (Masonry) grid layout
   * 
   * @requires https://github.com/desandro/imagesloaded
   * @requires https://github.com/Vestride/Shuffle
   */

  const masonryGrid = (() => {

      if ('undefined' === typeof Shuffle) {
          console.info('Shuffle is not loaded!');
          return;
      }
      if ('undefined' === typeof imagesLoaded) {
          console.info('imagesLoaded is not loaded!');
          return;
      }

      let grid = document.querySelectorAll('.masonry-grid'),
              masonry;

      if (grid === null) {
          return;
      }

      //for (let element of grid) {
      for (let i = 0; i < grid.length; i++) {
          let element = grid[i];
          masonry = new Shuffle(element, {
              itemSelector: '.masonry-grid-item',
              sizer: '.masonry-grid-item'
          });
          imagesLoaded(element).on('progress', () => {
              masonry.layout();
          });
      }
  })();

  /**
   * Toggling password visibility in password input
  */

  const passwordVisibilityToggle = (() => {

    let elements = document.querySelectorAll('.password-toggle');

    for (let i = 0; i < elements.length; i++) {
      let passInput = elements[i].querySelector('.form-control'),
      passToggle = elements[i].querySelector('.password-toggle-btn');

      passToggle.addEventListener('click', (e) => {
        
        if (e.target.type !== 'checkbox') return;
        if (e.target.checked) {
          passInput.type = 'text';
        } else {
          passInput.type = 'password';
        }

      }, false);
    }
  })();

  /**
   * Form validation
   */

  const formValidation = () => {

      const classBound = 'has-bound-validation';
      const selector = 'needs-validation';

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      let forms = document.getElementsByClassName(selector);

      // Loop over them and prevent submission
      //for (let form of forms) {
      for (let i = 0; i < forms.length; i++) {
          let form = forms[i];

          if (form.classList.contains(classBound)) {
              continue;
          }

          form.addEventListener('submit', (e) => {
              if (form.checkValidity() === false) {
                  e.preventDefault();
                  e.stopPropagation();
              }
              form.classList.add('was-validated');
          }, false);

          form.classList.add(classBound);
      }
  };

  window.addEventListener('load', formValidation, false);

  /**
   * Animate scroll to top button in/off view
  */

  const scrollTopButton = (() => {

    let element = document.querySelector('.btn-scroll-top'),
        scrollOffset = 600;
    
    if (element == null) return;

    let offsetFromTop = parseInt(scrollOffset, 10);
    
    window.addEventListener('scroll', (e) => {
      if (e.currentTarget.pageYOffset > offsetFromTop) {
        element.classList.add('show');
      } else {
        element.classList.remove('show');
      }
    });
  })();

  /**
   * Tooltip
   * @requires https://getbootstrap.com
   * @requires https://popper.js.org/
  */

  const tooltip = (() => {

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

    let tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl, { trigger: 'hover' }));

  })();

  /**
   * Popover
   * @requires https://getbootstrap.com
   * @requires https://popper.js.org/
  */

  const popover = (() => {

    let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));

    let popoverList = popoverTriggerList.map((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl));

  })();

  /**
   * Content carousel with extensive options to control behaviour and appearance
   * @requires https://github.com/ganlanyuan/tiny-slider
   */

  const carousel = () => {

      if ('undefined' === typeof tns) {
          console.info('tiny-slider is not loaded!');
          return;
      }

      const classBound = 'has-bound-carousel';
      const selector = `.tns-carousel .tns-carousel-inner:not(${classBound})`;
      let carousels = document.querySelectorAll(selector);

      //for (let element of carousels) {
      for (let i = 0; i < carousels.length; i++) {
          let element = carousels[i];

          if (element.classList.contains(classBound)) {
              continue;
          }

          // Carousel initialisation
          let defaults = {
              container: element,
              controlsText: ['<i class="ci-arrow-left"></i>', '<i class="ci-arrow-right"></i>'],
              navPosition: 'bottom',
              mouseDrag: true,
              speed: 500,
              autoplayHoverPause: true,
              autoplayButtonOutput: false
          };
          let userOptions = {};
          if (element.dataset.carouselOptions != undefined) {
              userOptions = JSON.parse(element.dataset.carouselOptions);
          }
          let options = Object.assign({}, defaults, userOptions);
          let carousel = tns(options);

          element.classList.add(classBound);
      }
  };

  carousel();

  /**
   * Lightbox component for presenting various types of media
   * @requires https://github.com/sachinchoolur/lightgallery.js
  */

  const gallery = (() => {

    let gallery = document.querySelectorAll('.gallery');
    if (gallery.length) {
      for (let i = 0; i < gallery.length; i++) {
        lightGallery(gallery[i], {
          selector: '.gallery-item',
          download: false,
          videojs: true,
          youtubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            rel: 0
          },
          vimeoPlayerParams: {
            byline: 0,
            portrait: 0,
            color: 'fe696a'
          }
        });
      }
    }
  })();

  /**
   * Shop product page gallery with thumbnails
   * @requires https://github.com/sachinchoolur/lightgallery.js
  */

  const productGallery = (() => {

    let gallery = document.querySelectorAll('.product-gallery');
    if (gallery.length) {

      for (let i = 0; i < gallery.length; i++) {
        
        let thumbnails = gallery[i].querySelectorAll('.product-gallery-thumblist-item:not(.video-item)'),
            previews = gallery[i].querySelectorAll('.product-gallery-preview-item'),
            videos = gallery[i].querySelectorAll('.product-gallery-thumblist-item.video-item');


        for (let n = 0; n < thumbnails.length; n++) {
          thumbnails[n].addEventListener('click', changePreview);
        }

        // Changer preview function
        function changePreview(e) {
          e.preventDefault();
          for (let i = 0; i < thumbnails.length; i++) {
            previews[i].classList.remove('active');
            thumbnails[i].classList.remove('active');
          }
          this.classList.add('active');
          gallery[i].querySelector(this.getAttribute('href')).classList.add('active');
        }

        // Video thumbnail - open video in lightbox
        for (let m = 0; m < videos.length; m++) {
          lightGallery(videos[m], {
            selector: 'this',
            download: false,
            videojs: true,
            youtubePlayerParams: {
              modestbranding: 1,
              showinfo: 0,
              rel: 0,
              controls: 0
            },
            vimeoPlayerParams: {
              byline: 0,
              portrait: 0,
              color: 'fe696a'
            }
          });
        }
      }
    }

  })();

  /**
   * Countdown timer
   */

  const countdown = (() => {

      let coundown = document.querySelectorAll('.countdown');

      if (coundown === null) {
          return;
      }

      for (let i = 0; i < coundown.length; i++) {

          let elementRoot = coundown[i],
                  endDate = coundown[i].dataset.countdown,
                  endDateMsg = coundown[i].dataset.timeisup,
                  daysVal = coundown[i].querySelector('.countdown-days .countdown-value'),
                  hoursVal = coundown[i].querySelector('.countdown-hours .countdown-value'),
                  minutesVal = coundown[i].querySelector('.countdown-minutes .countdown-value'),
                  secondsVal = coundown[i].querySelector('.countdown-seconds .countdown-value'),
                  days, hours, minutes, seconds, intervalId;

          endDate = new Date(endDate).getTime();

          if (isNaN(endDate)) {
              return;
          }

          if (!endDateMsg) {
              //endDateMsg = 'Čas vypšel!';
              endDateMsg = 'Akce již skončila';
              console.info("Countdown: data-timeisup is not set, use default.", {elementRoot, endDate});
          }

          intervalId = setInterval(calculate, 1000);

          function calculate() {
              let startDate = new Date().getTime();

              let timeRemaining = parseInt((endDate - startDate) / 1000);

              if (timeRemaining >= 0) {
                  days = parseInt(timeRemaining / 86400);
                  timeRemaining = (timeRemaining % 86400);

                  hours = parseInt(timeRemaining / 3600);
                  timeRemaining = (timeRemaining % 3600);

                  minutes = parseInt(timeRemaining / 60);
                  timeRemaining = (timeRemaining % 60);

                  seconds = parseInt(timeRemaining);

                  if (daysVal != null) {
                      daysVal.innerHTML = parseInt(days, 10);
                  }
                  if (hoursVal != null) {
                      hoursVal.innerHTML = hours < 10 ? '0' + hours : hours;
                  }
                  if (minutesVal != null) {
                      minutesVal.innerHTML = minutes < 10 ? '0' + minutes : minutes;
                  }
                  if (secondsVal != null) {
                      secondsVal.innerHTML = seconds < 10 ? '0' + seconds : seconds;
                  }
              } else {
                  elementRoot.innerHTML = endDateMsg + " " + (new Date(endDate)).toLocaleString();
                  clearInterval(intervalId);
                  return;
              }
          }
      }
  })();

  /**
   * Open YouTube / Vimeo video in lightbox
   * @requires @requires https://github.com/sachinchoolur/lightgallery.js
  */

  const videoButton = (() => {

    let button = document.querySelectorAll('[data-bs-toggle="video"]');
    if (button.length) {
      for (let i = 0; i < button.length; i++) {
        lightGallery(button[i], {
          selector: 'this',
          download: false,
          videojs: true,
          youtubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            rel: 0
          },
          vimeoPlayerParams: {
            byline: 0,
            portrait: 0,
            color: 'fe696a'
          }
        });
      }
    }

  })();

  /**
   * Range slider
   * @requires https://github.com/leongersen/noUiSlider
   */

  const rangeSlider = () => {

      if ('undefined' === typeof noUiSlider) {
          console.info('noUiSlider is not loaded!');
          return;
      }

      const classBound = 'has-bound-range-slider';
      const selector = `.range-slider:not(${classBound})`;
      let rangeSliderWidget = document.querySelectorAll(selector);

      //for (let element of rangeSliderWidget) {
      for (let i = 0; i < rangeSliderWidget.length; i++) {
          let element = rangeSliderWidget[i];

          if (element.classList.contains(classBound)) {
              continue;
          }

          let rangeSlider = element.querySelector('.range-slider-ui'),
                  valueMinInput = element.querySelector('.range-slider-value-min'),
                  valueMaxInput = element.querySelector('.range-slider-value-max'),
                  triggerInput = document.createElement('input');

          triggerInput.type = 'hidden';
          triggerInput.className = 'nfwE-filter-trigger';
          element.appendChild(triggerInput);

          let ds = element.dataset;

          let options = {
              dataStartMin: parseFloat(ds.startMin),
              dataStartMax: parseFloat(ds.startMax),
              dataMin: parseInt(ds.min, 10),
              dataMax: parseInt(ds.max, 10),
              dataStep: parseFloat(ds.step) || 1,
              dataUnitPre: ds.unitPre || '',
              dataUnitPost: ds.unitPost || ''
          };

          noUiSlider.create(rangeSlider, {
              start: [options.dataStartMin, options.dataStartMax],
              connect: true,
              step: options.dataStep,
              pips: {mode: 'count', values: 5},
              tooltips: true,
              range: {
                  'min': options.dataMin,
                  'max': options.dataMax
              },
              format: {
                  to: function (value) {
                      return options.dataUnitPre + Math.round(parseFloat(value) * 100) / 100 + options.dataUnitPost;
                  },
                  from: function (value) {
                      return Number(value);
                  }
              }
          });

          rangeSlider.noUiSlider.on('update', (values, handle) => {
              let value = values[handle];
              value = value.match(/^\D*(\d+([.,]\d+)?)\D*$/)[1];
              if (handle) {
                  valueMaxInput.value = Math.round(value * 100) / 100;
              } else {
                  valueMinInput.value = Math.round(value * 100) / 100;
              }
          });

          rangeSlider.noUiSlider.on('change', (values, handle, unencoded, tap, positions, noUiSlider) => {
              // values: Current slider values (array);
              // handle: Handle that caused the event (number);
              // unencoded: Slider values without formatting (array);
              // tap: Event was caused by the user tapping the slider (boolean);
              // positions: Left offset of the handles (array);
              // noUiSlider: slider public Api (noUiSlider);
              //console.log({values, handle, unencoded, tap, positions, noUiSlider});
              let event = new Event('change', {bubbles: true});
              triggerInput.dispatchEvent(event);
          });

          valueMinInput.addEventListener('change', function () {
              rangeSlider.noUiSlider.set([this.value, null]);
          });

          valueMaxInput.addEventListener('change', function () {
              rangeSlider.noUiSlider.set([null, this.value]);
          });

          element.classList.add(classBound);
      }
  };

  rangeSlider();

  /**
   * Filter list of items by typing in the search field
   */

  const filterList = () => {

      const classBound = 'has-bound-filter-search';
      const selector = `.widget-filter:not(${classBound})`;
      let filterListWidget = document.querySelectorAll(selector);

      //for (let element of filterListWidget) {
      for (let i = 0; i < filterListWidget.length; i++) {
          let element = filterListWidget[i];

          if (element.classList.contains(classBound)) {
              continue;
          }

          let filterInput = element.querySelector('.widget-filter-search'),
                  filterList = element.querySelector('.widget-filter-list'),
                  filterItems = filterList.querySelectorAll('.widget-filter-item');

          if (!filterInput) {
              continue;
          }

          filterInput.addEventListener('keyup', () => {

              let filterValue = filterInput.value.toLowerCase();
              for (let i = 0; i < filterItems.length; i++) {

                  let filterText = filterItems[i].querySelector('.widget-filter-item-text').innerHTML;
                  if (filterText.toLowerCase().indexOf(filterValue) > -1) {
                      filterItems[i].classList.remove('d-none');
                  } else {
                      filterItems[i].classList.add('d-none');
                  }
              }

          });

          element.classList.add(classBound);
      }
  };

  filterList();

  //import stickyNavbar from './components/sticky-navbar';
  //import dataFilter from './components/data-filter';
  //import labelUpdate from './components/label-update';
  //import radioTab from './components/radio-tab';
  //import creditCard from './components/credit-card';
  //import masterCheckbox from './components/master-checkbox';
  //import datePicker from './components/date-picker';//?
  //import dropdownSelect from './components/dropdown-select';//?

  const theme = {
      __debug: false,
      __stickyNavbar: false,
      lazyLoadInstance: null,
      stickySidebarInstance: null,
      console: {
          log: function () {
              if (theme.__debug) {
                  console.log.apply(this, arguments);
              }
          },
          info: function () {
              if (theme.__debug) {
                  console.info.apply(this, arguments);
              }
          },
          warn: console.warn,
          error: console.error
      },
      /**
       * @param {type} debug
       * @returns {@var;debug|theme.__debug|Boolean}
       */
      debug: function (debug = null) {
          if (debug !== null) {
              theme.__debug = debug;
          }
          if (theme.__debug) {
              console.info('Debug mode is enabled!');
          }
          return theme.__debug;
      },
      /**
       * @returns {Boolean}
       */
      isMobileView: () => {
          //theme.console.log([jQuery('#nfwTpl-mobile').is(':visible'),jQuery('#nfwTpl-desktop').is(':visible')]);
          return jQuery('#nfwTpl-mobile').is(':visible');
      },
      /**
       * @returns {undefined}
       */
      lazyloadInit: () => {

          // Set the options globally to make LazyLoad self-initialize
          window.lazyLoadOptions = {
              // Your custom settings go here
          };
          // Listen to the initialization event and get the instance of LazyLoad
          window.addEventListener(
                  "LazyLoad::Initialized",
                  function (event) {
                      theme.lazyLoadInstance = event.detail.instance;
                      //theme.console.log("LazyLoad::Initialized");
                  },
                  false
                  );
      },
      /**
       * @returns {undefined}
       */
      lazyloadUpdate: () => {
          if (theme.lazyLoadInstance) {
              theme.lazyLoadInstance.update();
              //theme.console.log("LazyLoad::Update");
          }
      },
      /**
       * @returns {undefined}
       */
      stickySidebarInit: () => {

          if ('undefined' === typeof StickySidebar) {
              theme.console.info('StickySidebar is not loaded');
              return null;
          }

          let element = document.querySelector('.sticky-sidebar');
          if (element === null) {
              return;
          }

          let sidebar = new StickySidebar(element, {
              //containerSelector: '#main-content',
              innerWrapperSelector: '.sticky-sidebar__inner',
              topSpacing: theme.__stickyNavbar ? 123 : 25, // to avoid collision with sticky menu
              bottomSpacing: 25,
              minWidth: 991,
              resizeSensor: false, // never will be loaded
          });

          theme.stickySidebarInstance = sidebar;
          //theme.console.log("theme.stickySidebarInit");
      },
      /**
       * @returns {undefined}
       */
      stickySidebarUpdate: () => {
          if (theme.stickySidebarInstance) {
              let ts = theme.stickySidebarInstance;
              //theme.console.log("TC: theme.stickySidebarUpdate", ts, ts.affixedType, ts._running);
              ts.updateSticky();
              //theme.console.log("theme.stickySidebarUpdate", ts, ts.affixedType, ts._running);
          }
      },
      filterList: filterList,
      rangeSlider: rangeSlider,
      carousel: carousel,
      formValidation: formValidation,
      //
      /**
       * @param {string} path
       * @param {callable} fnSuccess
       * @param {callable} fnFail
       * @returns {Promise}
       */
      ajaxPage: (path, fnSuccess, fnFail) => {

          const myResponse = fetch(`/ajax-pages/${path}`, {
              method: 'GET',
              headers: {
                  'X-Requested-With': 'XMLHttpRequest', // to let core know to strip layout... (as jQuery.get() does..)
              },
          });

          myResponse
                  .then(response => {
                      if (!response.ok) {
                          throw new Error('Network response was not OK');
                      }
                      return response.text();
                  })
                  .then(responseData => {
                      fnSuccess(responseData);
                  })
                  .catch((error) => {
                      theme.console.error('ajaxPage error ' + error);
                      fnFail(error);
                  });

          return myResponse;
      },
      //
      init: () => {
          theme.debug(jQuery('#nfwTpl-debug').length > 0);

          theme.lazyloadInit();
          theme.stickySidebarInit();
      },
  };

  /**
   * Init theme core
   */

  theme.init();

  window.czTheme = theme;

}());
